module.exports = "/assets/data/8f1878e3af8c89c7f4b99517c71e523b-M1.data.json";